import { ICartEntry } from 'features/cart/types';
import { calculateCartSubTotal, calculateEntryTotalPrice } from 'features/cart/utils';
import { Divider } from 'native-base';
import { ScrollView, Text, View } from 'react-native';

import { InlineModal } from 'components/ui';

const CartDebugSubtotalItem = ({ entry, level = 0 }: { entry: ICartEntry; level?: number }) => {
  return (
    <>
      <View style={{ flexDirection: 'row', gap: 6, marginBottom: 6 }}>
        <Text style={{ flex: 1, marginLeft: level * 20 }}>
          {entry.quantity} x {entry.name}
        </Text>
        <Text style={{ fontFamily: 'monospace', textAlign: 'right' }}>{entry.price?.amount}</Text>
      </View>
      {entry.children.map(child => (
        <CartDebugSubtotalItem key={child.id} entry={child} level={level + 1} />
      ))}
      {level === 0 && (
        <>
          <View style={{ flexDirection: 'row', gap: 6, marginBottom: 10 }}>
            <Text style={{ flex: 1, fontWeight: '500' }}>Item Total:</Text>
            <Text style={{ fontFamily: 'monospace', textAlign: 'right', fontWeight: '600' }}>
              {calculateEntryTotalPrice(entry)}
            </Text>
          </View>
          <Divider mb="4" />
        </>
      )}
    </>
  );
};

export const CartDebugSubtotalModal = ({
  isOpen,
  onClose,
  cartEntries,
}: {
  isOpen: boolean;
  onClose: () => void;
  cartEntries: ICartEntry[];
}) => {
  return (
    <InlineModal
      isOpen={isOpen}
      onClose={onClose}
      header={{ title: `Debug SubTotal`, variant: 'light' }}
    >
      <ScrollView>
        {/* show cart entries with price and quantity display the nested children with an indent children can have children*/}
        {cartEntries.map(entry => (
          <CartDebugSubtotalItem key={entry.id} entry={entry} />
        ))}

        <View style={{ flexDirection: 'row', gap: 6, marginBottom: 10 }}>
          <Text style={{ flex: 1, fontWeight: '600', fontSize: 16 }}>SubTotal:</Text>
          <Text
            style={{ fontFamily: 'monospace', textAlign: 'right', fontWeight: '600', fontSize: 16 }}
          >
            {calculateCartSubTotal(cartEntries)}
          </Text>
        </View>
      </ScrollView>
    </InlineModal>
  );
};
